import React, { useContext } from 'react';
import { IDishAssignmentContext, DishAssignmentContext } from '../../dishAssignmentState/dishAssignmentContext';
import Heading from './components/Heading/Heading';
import SubcategoriesControlPanel from './components/SubcategoriesControlPanel/SubcategoriesControlPanel';
import SearchFields from './components/SearchFields/SearchFields';
import Breadcrumbs from './components/Breadcrumbs/Breadcrumbs';
import NotificationsForCategory from './components/NotificationsForCategory/NotificationsForCategory';
import Categories from './components/Categories/Categories';
import Subcategories from './components/Subcategories/Subcategories';
import Dishes from './components/Dishes/Dishes';
import BottomControlPanel from './components/BottomControlPanel/BottomControlPanel';
import CancelAndSaveButtons from './components/CancelAndSaveButtons/CancelAndSaveButtons';
import classNames from 'classnames';
import style from './SubcategoriesSection.module.scss';

const SubcategoriesSection: React.FC = () => {
	const { activeItemToDisplay, categories, subcategories, dishes } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const sectionCategoriesClasses = classNames(style.sectionWrapper, {
		[style.hide]: activeItemToDisplay !== 'categories',
	});
	const sectionSubcategoriesClasses = classNames(style.sectionWrapper, {
		[style.hide]: activeItemToDisplay !== 'subCategories',
	});
	const sectionDishesClasses = classNames(style.sectionWrapper, style.marginTopZero, {
		[style.hide]: activeItemToDisplay !== 'dishes',
	});

	return (
		<div className={style.container} data-test="SubcategoriesSection">
			<div className={style.wrapper}>
				<div>
					<Heading />
					<SubcategoriesControlPanel />
					<SearchFields />
					<Breadcrumbs />
					<div className={style.sections}>
						<div className={sectionCategoriesClasses}>
							{categories.length ? <Categories /> : <NotificationsForCategory />}
						</div>
						<div className={sectionSubcategoriesClasses}>
							{subcategories.length ? <Subcategories /> : null}
						</div>
						<div className={sectionDishesClasses}>{dishes.length ? <Dishes /> : null}</div>
					</div>
				</div>
				<BottomControlPanel />
			</div>
			<CancelAndSaveButtons />
		</div>
	);
};

export default SubcategoriesSection;
